// extracted by mini-css-extract-plugin
module.exports = {"panel":"StreamContentTabPanels_panel__we4UO","participantsPanel":"StreamContentTabPanels_participantsPanel__AaSkD"};